import { useEffect, useMemo, useState } from "react";
import apiService, { formatRupees, handleError } from "../../Common/ApiCommon/ApiService";
import PayNowPlayer from "../Customer/PayNowPlayer";

const useAddDues = () => {
    const [customerData, setCustomerData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(15);
    const [loading, setLoading] = useState(false);
    const [showPayNow, setShowPayNow] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    // Fetch customer data from the API
    const fetchCustomers = async () => {
        setLoading(true);
        try {
            let url = "/customer_users";
            const params = new URLSearchParams();
            if (searchQuery) params.append("search", searchQuery);

            const response = await apiService.get(`${url}?${params.toString()}`);
            setCustomerData(response.data);
        } catch (errors) {
            handleError(errors);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCustomers();
    }, [searchQuery]);

    const handlePayNow = (id) => {
        setShowPayNow(id);
    }


    // Define table columns
    const columns = useMemo(
        () => [
            {
                Header: "Player ID",
                accessor: "customer_uniq_id",
                headerAlign: "text-center",
                cellAlign: "text-center",
                Cell: ({ value }) => <div className="text-nowrap">{value}</div>,
            },
            {
                Header: "Player Name",
                accessor: "customerName",
                headerAlign: "text-left",
                cellAlign: "text-left",
                Cell: ({ row }) => <span>{row.original.customerName}</span>,
            },
            {
                Header: "Amount",
                accessor: "amount",
                headerAlign: "text-left",
                cellAlign: "text-left",
                Cell: ({ value }) => <span className="text-gray-700 text-sm">{value}</span>,
            },
            {
                Header: "Action",
                accessor: "action",
                headerAlign: "text-center",
                cellAlign: "text-center",
                disableSortBy: true,
                Cell: ({ row }) => {
                    const amountValue = Number(row.original.amount.replace(/[^\d.-]/g, "")) || 0;
                    return (
                        <>
                            {/* pay now */}

                            <button
                                className="text-white text-center rounded-[32px] w-[100px] px-4 py-2 bg-checkoutblue cursor-pointer"
                                onClick={() => handlePayNow(row.original.id)}
                            >
                                Pay Now
                            </button>
                            {showPayNow === row.original.id && (
                                <PayNowPlayer
                                    isOpen={showPayNow === row.original.id}
                                    onClose={() => handlePayNow(null)}
                                    fetchCustomers={fetchCustomers}
                                    customerId={row.original.id}
                                    dueamount={amountValue}
                                    customerName={row.original.customerName}
                                />
                            )}
                        </>
                    )
                },
            }
        ],
        [showPayNow]
    );

    // Process customer data and filter players with amount > 0
    const data = useMemo(() => {
        if (!Array.isArray(customerData)) return [];

        return customerData
            .filter((customer) => customer.amount > 0)
            .map((customer) => ({
                id: customer.id,
                status: customer.status === "activated" ? "Active" : "Deactive",
                customer_uniq_id: customer.customer_uniq_id || "-",
                customerName: customer.full_name || "N/A",
                city: customer.city || "Unknown",
                amount: formatRupees(customer.amount || 0),
                due_limit: formatRupees(customer.due_limit) || "₹ 0"

            }));
    }, [customerData]);

    // Paginate the data
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);

    // Handle page change
    const handlePageChange = (newPage) => setCurrentPage(newPage);

    // Handle rows per page change
    const handleRowsPerPageChange = (newRowsPerPage) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    return {
        columns,
        currentRows,
        totalRows: data.length,
        currentPage,
        rowsPerPage,
        handlePageChange,
        handleRowsPerPageChange,
        loading,
        searchQuery,
        setSearchQuery,
    };
};

export default useAddDues;
